module.exports = __webpack_public_path__ + "img/souvenirs-01.67e9f5f3.png";